
define(
	'NVT.AnnualApplicationFormE.AnnualApplicationFormE'
,   [
		'NVT.AnnualApplicationFormE.AnnualApplicationFormE.View'
	]
,   function (
		AnnualApplicationFormEView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */

			var layout = container.getComponent('Layout');

			if (layout) {
					layout.on('afterShowContent', function() {		
					var layoutDisplayed = window.location.href.indexOf("AnnualApplicationFormE") != -1;
					if (layoutDisplayed == true) {
						jQuery("#site-header").remove();
						jQuery("#site-footer").remove();
					}					
			  	});
			}

			var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'annual_application_form_e',
                routes: ['AnnualApplicationFormE'],
                view: AnnualApplicationFormEView,
                defaultTemplate: {
                    name: 'nvt_annualapplicationforme_annualapplicationforme.tpl',
                    displayName: 'Form E'
                }
            });

            var MyAccountMenu = container.getComponent('Application');
            if(MyAccountMenu)
            {
                MyAccountMenu.getComponent().renderHeader();
            }
                

		}
	};
});
